var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1662_27954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 37.4785 40.8574 47.8213 28.9062 49.6963V32.2266H34.7314L35.8398 25H28.9062V20.3105C28.9062 18.333 29.875 16.4062 32.9805 16.4062H36.1328V10.2539C36.1328 10.2539 33.2715 9.76562 30.5361 9.76562C24.8262 9.76562 21.0938 13.2266 21.0938 19.4922V25H14.7461V32.2266H21.0938V49.6963C9.14258 47.8213 0 37.4785 0 25C0 11.1934 11.1934 0 25 0C38.8066 0 50 11.1934 50 25Z",
    fill: "url(#paint0_linear_1662_27954)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7314 32.2266L35.8398 25H28.9062V20.3104C28.9062 18.3334 29.8748 16.4062 32.9804 16.4062H36.1328V10.2539C36.1328 10.2539 33.2719 9.76562 30.5366 9.76562C24.8261 9.76562 21.0938 13.2266 21.0938 19.4922V25H14.7461V32.2266H21.0938V49.6962C22.3666 49.8959 23.6711 50 25 50C26.3289 50 27.6334 49.8959 28.9062 49.6962V32.2266H34.7314Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1662_27954",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 56.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1877F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1453A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1662_27954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5194313d5df5a3a4bd897212d4336d21.svg";
export { ForwardRef as ReactComponent };